import * as Phaser from "phaser";
import axios, { AxiosInstance } from "axios";
import { CommonVarsGlobalPlugin } from "$/game/plugins/CommonVarsGlobalPlugin.ts";

export class ApiGlobalPlugin extends Phaser.Plugins.BasePlugin {
  private global!: CommonVarsGlobalPlugin;
  private registry!: Phaser.Data.DataManager;
  private httpClient!: AxiosInstance;

  constructor(pluginManager: Phaser.Plugins.PluginManager) {
    super(pluginManager);
  }

  override start(): void {
    this.registry = this.pluginManager.game.registry;
    this.global = this.pluginManager.game.plugins.get(
      "globalVars",
    ) as CommonVarsGlobalPlugin;

    this.httpClient = axios.create({
      baseURL: "/api",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "twa " + this.global.TWA?.initData,
      },
    });
  }

  public pet = {
    get: async () => {
      const result = await this.httpClient.get("/pet");

      if (result.data == null) {
        this.registry.set("pet", null);
      } else {
        this.registry.set("pet", result.data);
      }

      return result;
    },

    create: async (type: string) => {
      const result = await this.httpClient.post("/pet", {
        type,
      });

      return result;
    },

    useSoap: async () => {
      const result = await this.httpClient.post("/pet/action", {
        action: "soap",
      });

      if (result.data != null) {
        this.registry.set("pet", result.data);
      }

      return result;
    },

    playBall: async () => {
      const result = await this.httpClient.post("/pet/action", {
        action: "ball",
      });

      return result;
    },

    cleanPoop: async () => {
      try {
        const result = await this.httpClient.post("/pet/action-item", {
          action: "clean",
        });

        return result;
      } catch (error) {
        console.error("Error cleaning poop:", error);
        return null;
      }
    },

    sleepStart: async () => {
      const result = await this.httpClient.post("/pet/action", {
        action: "sleep-start",
      });

      return result;
    },

    sleepEnd: async () => {
      const result = await this.httpClient.post("/pet/action", {
        action: "sleep-end",
      });

      return result;
    },

    energyRestore: async (byAd: boolean = false) => {
      const result = await this.httpClient.post("/pet/action", {
        action: byAd ? "energy-restore-by-ad" : "energy-restore",
      });

      if (result.data != null) {
        this.registry.set("pet", result.data);
      }

      return result;
    },

    moodRestore: async (byAd: boolean = false) => {
      const result = await this.httpClient.post("/pet/action", {
        action: byAd ? "mood-restore-by-ad" : "mood-restore",
      });

      if (result.data != null) {
        this.registry.set("pet", result.data);
      }

      return result;
    },

    satietyRestore: async (byAd: boolean = false) => {
      const result = await this.httpClient.post("/pet/action", {
        action: byAd ? "satiety-restore-by-ad" : "satiety-restore",
      });

      if (result.data != null) {
        this.registry.set("pet", result.data);
      }

      return result;
    },

    cleanRestore: async (byAd: boolean = false) => {
      const result = await this.httpClient.post("/pet/action", {
        action: byAd ? "clean-restore-by-ad" : "clean-restore",
      });

      if (result.data != null) {
        this.registry.set("pet", result.data);
      }

      return result;
    },

    buyFood: async () => {
      const result = await this.httpClient.post("/pet/action-item", {
        action: "buy-food",
      });

      if (result.data != null) {
        this.registry.set("pet", result.data);
      }

      return result;
    },

    feed: async () => {
      const result = await this.httpClient.post("/pet/action-item", {
        action: "feed",
      });

      if (result.data != null) {
        this.registry.set("pet", result.data);
      }

      return result;
    },

    reviveByAd: async () => {
      const result = await this.httpClient.put("/pet/revive");

      if (result.data != null) {
        this.registry.set("pet", result.data);
      }

      return result;
    },
  };

  public user = {
    authenticate: async () => {
      const result = await this.httpClient.post("/user");

      if (result.data == null) {
        this.registry.set("user", null);
      } else {
        this.registry.set("user", result.data);
      }

      return result;
    },
    entry: async () => {
      const result = await this.httpClient.post("/user/entry");
      return result;
    },
    exit: async () => {
      const result = await this.httpClient.post("/user/exit");
      return result;
    },
    share: async () => {
      const response = await this.httpClient.post("/user/create-share-message");
      return await response.data;
    },
    donate: async () => {
      const response = await this.httpClient.post("/user/donate");
      return await response.data;
    },
  };

  public payment = {
    createPetReviveInvoice: async () => {
      const result = await this.httpClient.post(
        "/payment/create-pet-revive-invoice",
      );
      return result;
    },
    createInvoice: async (code: string) => {
      const result = await this.httpClient.post(
        "/payment/create-invoice",
        { code },
      );
      return result;
    },
  };

  public miniGame = {
    postScore: async (score: number) => {
      const result = await this.httpClient.post("/mini-game", { score });
      return result;
    },

    createShareMessage: async (score: number) => {
      const response = await this.httpClient.post(
        "/mini-game/create-share-message",
        { score },
      );
      return await response.data;
    },

    getLeaderboard: async () => {
      const response = await this.httpClient.get("/mini-game/leaderboard");
      return await response.data;
    },
  };
}
